import { AppConfig } from "../data/loadConfiguration"

export function useHasConcept(config: AppConfig): boolean {
    return !!config.login?.props?.conceptStyle || !!config.params?.conceptStyle
}
